import { render } from "./TableControl.vue?vue&type=template&id=fd96ac6a&scoped=true"
import script from "./TableControl.vue?vue&type=script&lang=js"
export * from "./TableControl.vue?vue&type=script&lang=js"

import "./TableControl.vue?vue&type=style&index=0&id=fd96ac6a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd96ac6a"]])

export default __exports__